<template lang="pug">
  v-dialog(
    v-model="dialog"
    v-bind="extendAttrs"
    v-on="extendListeners"
    attach
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")

    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")

    slot(name="dialog" v-bind="{ close }")
      v-card
        slot(
          v-if="!hideHeader"
          name="header"
        )
          v-list-item.px-6
            v-list-item-content
              h6.text-h6(v-if="title") {{ title }}
            v-list-item-action
              slot(name="header.close")
                v-btn(icon @click="close"): v-icon {{ closeIcon }}

        v-card-text
          slot(name="content" v-bind="{ close }")

        v-card-actions(v-if="!hideActions")
          slot(name="actions" v-bind="{ close }")
</template>

<script>
export default {
  name: 'EvDialog',
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: '' },
    hideHeader: { type: Boolean, default: false },
    hideActions: { type: Boolean, default: false },
    maxHeight: { type: String, default: '90%' },
    closeIcon: { type: String, default: 'mdi-close' },
  },
  data() {
    return {
      dialog: this.value,
    };
  },
  computed: {
    styleList() {
      const { $attrs } = this;

      return {
        ...$attrs.style,
        '--dialog-max-height': this.maxHeight,
      };
    },
    extendAttrs() {
      const { $attrs } = this;
      return {
        ...$attrs,
        style: this.styleList,
      };
    },
    extendListeners() {
      return {
        ...this.$listeners,
        input: (val) => this.$emit('input', val),
      };
    },
  },
  methods: {
    // This construction fixed delete dialog overlay;
    async close() {
      new Promise((resolve) => {
        this.dialog = false;
        resolve();
      }).then(() => {
        this.$emit('close');
      });
    },
  },
};
</script>
